import 'core-js/stable'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from 'frame'
import * as serviceWorker from './serviceWorker'

const render = Component => {
  createRoot(document.getElementById('root')).render(<Component />)
}

render(App)

if (module.hot) {
  module.hot.accept('./frame/containers/app', () => {
    const NextApp = require('./frame/containers/app').default
    render(NextApp)
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
